<template>
  <div class="guest">
    <form class="signin-form" autocomplete="off">

      <grid :gap="3">
        <div class="is-flex justify-center"><logo width="10rem" /></div>
        <h3 class="title is-5 has-text-weight-light has-text-centered leading-spaced">Start securing your App with Snitch today,<br> with a <span class="has-text-white-bis">7-day free trial</span>.</h3>
      </grid>

      <grid class="mb-2 mt-3">
        
        <name-input
          v-focus
          required
          classes="is-medium has-addons"
          placeholder="Your full name"
          store="auth"
          mutation="updateName"
        />

        <email-input
          email-icon
          required
          autocomplete="new-password"
          classes="is-medium has-addons"
          placeholder="Email address"
          store="auth"
        />

        <user-password-input
          required
          meter
          reveal="toggle"
          reveal-class="is-medium"
          autocomplete="new-password"
          classes="is-medium"
          placeholder="Password"
          field="password"
          mutation="updatePassword"
          store="auth"
        />

        <submit-button
          @submit="signUp"
          :disabled="!canSignUp"
          :working="signingUp"
          class="ptb-2 is-primary is-rounded is-medium mt-1 has-text-weight-bold">
          Sign Up
        </submit-button>

        <hr />

        <h3 class="title is-4 has-text-white-ter has-text-weight-light has-text-centered">Already have an account?</h3>

        <div class="buttons is-centered">
          <route
            :disabled="signingUp"
            name="signin"
            class="button is-primary has-text-weight-bold is-rounded is-outlined">
            <span class="mlr-2">Sign In</span>
          </route>
        </div>
      </grid>
    </form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {

  data: () => ({
    signingUp: false,
  }),

  created() {
    this.$bus.$emit('set-title', 'Get Started')
  },

  methods: {

    signUp() {
      this.signingUp = true
      this.$store
        .dispatch('auth/signUp')
        .then(() => {
          this.$router.push({ name: 'signin' })
          this.$toast.info('Welcome to Snitch!')
        })
        .catch((error) => {
          setTimeout(this.stopSigningUp(error), 2000)
        })
    },

    stopSigningUp(error) {
      this.signingUp = false
      this.$toast.warning(
        'Unable to sign in',
        error?.response?.data?.error || 'We can’t sign you up at this time due to a technical error. Please try again in a minute.'
      )
    },
  },

  computed: {
    ...mapGetters('auth', [
      'canSignUp'
    ])
  }

}
</script>
